import React from 'react'
import {getDoc,doc,updateDoc } from "firebase/firestore"
import {auth, db, functions} from  '../../firebase.js';
import d16 from './Ratings.module.css'
import {
   MdOutlineSentimentDissatisfied,
   MdSentimentSatisfied,
   MdSentimentVerySatisfied, } from 'react-icons/md'
import { httpsCallable } from 'firebase/functions';


function Ratings(props) {

   let func= httpsCallable(functions, 'rateTutor');
    function updateRatings(rate){
      func({
         tutor_id: props.questionData.taken_by.id,
         question_id: props.questionData.question_id,
         rating: rate, 
          }).then((res)=>{console.log(res.data)})

    }


    return (
      props.questionData.sender_id===auth.currentUser.uid && (props.questionData.question_status === 'done' || props.questionData.question_status === 'read') && 
      
      <div>
          
         {(props.questionData.question_rating && props.questionData.question_rating!==-1 )
      ?
      <div className={d16.results} >
         Rating:
        {props.questionData.question_rating===1 && <div className={d16.red}>Not understood <MdOutlineSentimentDissatisfied size='25'/></div>}
        {props.questionData.question_rating===2 && <div className={d16.yellow}>Half understood  <MdSentimentSatisfied size='25'/></div>}
        {props.questionData.question_rating===3 && <div className={d16.blue}>Completly understood <MdSentimentVerySatisfied size='25'/></div>}
       
      </div>
      :


!(props.questionData.question_rating && props.questionData.question_rating!==-1 ) 
&&
           <div className={d16.RatingButtonContainer}>
           Ratings:
               <ul>
              <li onClick={()=>updateRatings(1)} >I didn't understand <MdOutlineSentimentDissatisfied size='25'/> </li>
              <li onClick={()=>updateRatings(2)}> Half Understood <MdSentimentSatisfied size='25'/></li>
              <li onClick={()=>updateRatings(3)}>Perfectly Understood <MdSentimentVerySatisfied size='25'/></li>
              </ul>
           </div>}
        </div>
    )
}

export default Ratings
